import React from "react";

const Voucher = () => {
  return (
    <div className="bank-mid mt-4 col col-10">
      <div>
        <div className="row hidden-md-and-up" style={{ height: "75px" }}>
          <div className="voucher-mobile-header text-center col col-12">
            Claim Voucher
          </div>
        </div>
        <div className="desktop_card voucher_claim v-card v-sheet theme--light">
          <div className="v-card__title hidden-sm-and-down">
            <label className="--v-primary-base text-left text-capitalize mr-4">
              Claim Voucher
            </label>
          </div>
          <div className="bank-detail-card voucher-card v-card v-sheet theme--light elevation-0">
            <div className="row px-8 pa-4 no-gutters align-end">
              <div className="col-md-5 col-lg-4 col">
                <form noValidate="novalidate" className="v-form">
                  <div className>
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block pb-2"
                          style={{ float: "left" }}
                        >
                          Apply Voucher<span className="red--text ml-1">*</span>
                        </label>
                      </div>
                      <div className="col col-2">{/**/}</div>
                      <div className="col col-12">
                        <div className="v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                <input
                                  autoComplete="new-password"
                                  id="input-774"
                                  placeholder="Voucher Code"
                                  type="text"
                                />
                              </div>
                            </div>
                            <div className="v-text-field__details">
                              <div className="v-messages theme--light">
                                <div className="v-messages__wrapper" />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/**/}
                        {/**/}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="row px-8 pa-4 no-gutters align-end">
              <div className="col-md-5 col-lg-4 col">
                <button
                  data-v-1dea3caa
                  type="button"
                  className="full-width font-weight-bold pa-2 dialog-button submit-btn v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary theme-button theme--light subtitle-1"
                  readOnly="readonly"
                >
                  <span className="v-btn__content">Submit</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Voucher;
